import {
    Autocomplete,
    Button,
    Chip,
    IconButton,
    Stack,
    TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { GridToolbarContainer } from "@mui/x-data-grid-pro";

import CustomTooltip from "src/components/visibility/components/CustomTooltip";
import Iconify from "src/components/iconify";

export interface CustomToolbarProps {
    toolbarRef: any;
    apiRef: any;
    selectionRows: any[];

    canImport: boolean;
    onOpenCsvImport?: () => void;

    selectedDateRange: any;
    selectedCompareDate: any;

    onDateRangeChange?: (value: any) => void;
    onCompareDateChange?: (value: any) => void;

    modifiedRows: any[];
    setModifiedRows: any;
    setLocalPatches: any;

    handleUpdateMaxCPC: (rows: any[]) => void;

    setModalDeactivateStrategy: any;
    setModalScraping?: any;
    setModalCreateStrategy: any;
    setOpenEnforceModal: any;

    disableScraping?: boolean;

    dateRangeOptions: any[];
    comparisonPeriodOptions: any[];
}

export default function CustomToolbar(props: CustomToolbarProps) {
    const {
        toolbarRef,
        apiRef,
        selectionRows,
        canImport,
        onOpenCsvImport,
        selectedDateRange,
        selectedCompareDate,
        onDateRangeChange,
        onCompareDateChange,
        modifiedRows,
        setModifiedRows,
        setLocalPatches,
        handleUpdateMaxCPC,
        setModalDeactivateStrategy,
        setModalScraping,
        setModalCreateStrategy,
        setOpenEnforceModal,
        dateRangeOptions,
        comparisonPeriodOptions,
        disableScraping,
    } = props;

    return (
        <GridToolbarContainer
            ref={toolbarRef}
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: 40,
                minHeight: 40,
                px: "20px",

                "& .MuiButton-root": {
                    height: 32,
                    minHeight: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textTransform: "none",
                },

                "& .MuiAutocomplete-root": {
                    display: "flex",
                    alignItems: "center",
                },

                "& .MuiInputBase-root": {
                    height: 32,
                    minHeight: 32,
                    display: "flex",
                    alignItems: "center",
                    paddingTop: "0 !important",
                    paddingBottom: "0 !important",
                },

                "& .MuiAutocomplete-input": {
                    padding: "0 !important",
                },

                "& .MuiChip-root": {
                    height: 24,
                },
            }}
        >
            {/* LEFT */}
            <Stack
                direction="row"
                alignItems="center"
                spacing={0.5}
                sx={{ height: "100%" }}
            >
                <CustomTooltip title={"Show More KPIs"} arrow placement="top">
                    <IconButton
                        onClick={() => apiRef.current?.showPreferences("columns")}
                        sx={{
                            width: 26,
                            height: 26,
                            padding: 0,
                            color: "#919EAB",
                            "&:hover": {
                                backgroundColor: "action.hover",
                            },
                        }}
                    >
                        <Iconify
                            icon="mingcute:calendar-week-line"
                            width={18}
                            height={18}
                        />
                    </IconButton>
                </CustomTooltip>

                <CustomTooltip title={"Apply Filters"} arrow placement="top">
                    <IconButton
                        onClick={() => apiRef.current?.showFilterPanel()}
                        sx={{
                            width: 26,
                            height: 26,
                            padding: 0,
                            color: "#919EAB",
                            "&:hover": {
                                backgroundColor: "action.hover",
                            },
                        }}
                    >
                        <Iconify
                            icon="ic:round-filter-list"
                            width={18}
                            height={18}
                        />
                    </IconButton>
                </CustomTooltip>

                <CustomTooltip title={"Download Table"} arrow placement="top">
                    <IconButton
                        onClick={() =>
                            apiRef.current?.exportDataAsCsv({
                                fileName: "exact_activations",
                                utf8WithBom: true,
                            })
                        }
                        sx={{
                            width: 26,
                            height: 26,
                            padding: 0,
                            color: "#919EAB",
                            "&:hover": {
                                backgroundColor: "action.hover",
                            },
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M14 10V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V10M4.66667 6.66667L8 10L11.3333 6.66667M8 10V2" stroke="#919EAB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </IconButton>
                </CustomTooltip>

                {canImport && (
                    <CustomTooltip title={"Import KO Bidding Manual"} arrow placement="top">
                        <IconButton
                            onClick={onOpenCsvImport}
                            sx={{
                                width: 24,
                                height: 24,
                                padding: 0,
                                color: '#919EAB',
                                '&:hover': {
                                    backgroundColor: 'action.hover',
                                }
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M14 8V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V8M5.33333 4.66667L8 2L10.6667 4.66667M8 2V10" stroke="#919EAB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </IconButton>
                    </CustomTooltip>
                )}
            </Stack>

            {/* RIGHT */}
            <Box
                display="flex"
                alignItems="center"
                sx={{ height: "100%" }}
            >
                {selectionRows.length >= 1 && (

                    <Button
                        onClick={() =>
                            setOpenEnforceModal({
                                open: true,
                                row: selectionRows,
                            })
                        }
                        sx={{
                            backgroundColor:
                                "rgba(145, 158, 171, 0.20)",
                            borderRadius: "8px",
                            px: 1.5,
                            mr: 1,
                        }}
                        size="small"
                    >
                        Enforce Max CPC ({selectionRows.length})
                    </Button>
                )}

                {selectionRows.length > 1 && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        <Button
                            onClick={() =>
                                setModalDeactivateStrategy({
                                    open: true,
                                    row: selectionRows,
                                })
                            }
                            sx={{
                                backgroundColor:
                                    "rgba(145, 158, 171, 0.20)",
                                borderRadius: "8px",
                                px: 1.5,
                            }}
                            size="small"
                        >
                            Deactivate Bidding Strategy (
                            {selectionRows.length})
                        </Button>

                        {!disableScraping &&
                            <Button
                                onClick={() =>
                                    setModalScraping({
                                        open: true,
                                        row: selectionRows,
                                    })
                                }
                                size="small"
                                variant="contained"
                            >
                                Active Scraping ({selectionRows.length})
                            </Button>
                        }

                        <Button
                            onClick={() =>
                                setModalCreateStrategy({
                                    open: true,
                                    row: selectionRows,
                                })
                            }
                            size="small"
                            variant="contained"
                            sx={{ mr: 1 }}
                        >
                            Activate Bidding Strategy (
                            {selectionRows.length})
                        </Button>
                    </Box>
                )}

                <Box
                    display="flex"
                    alignItems="center"
                    position="relative"
                >
                    {modifiedRows.length > 0 && (
                        <Box display={"flex"} flexDirection={"row"} gap={1} px={1}>
                            <Button
                                onClick={() => {
                                    setModifiedRows([]);
                                    setLocalPatches({});
                                }}
                                size="small"
                                variant="contained"
                            >
                                Discard ({modifiedRows.length})
                            </Button>

                            <Button
                                onClick={() => handleUpdateMaxCPC(modifiedRows)}
                                size="small"
                                variant="contained"
                                sx={{
                                    minWidth: "unset",
                                    padding: "2px 6px !important",
                                    fontSize: "12px !important",
                                    lineHeight: 1.2,
                                }}
                            >
                                Apply ({modifiedRows.length})
                            </Button>
                        </Box>
                    )}

                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        pr={"20px"}
                    >
                        <Autocomplete
                            disablePortal
                            options={dateRangeOptions}
                            size="small"
                            disableClearable
                            onChange={(event, newValue) => {
                                onDateRangeChange?.(newValue);
                            }}
                            getOptionLabel={(option) => option.label}
                            sx={{ width: 150 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment:
                                            selectedDateRange ? (
                                                <Chip
                                                    label={
                                                        selectedDateRange.label
                                                    }
                                                    size="small"
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.50)",
                                                        },
                                                        backgroundColor:
                                                            "rgba(145, 158, 171, 0.32)",
                                                        color:
                                                            "rgba(51, 60, 71, 1)",
                                                    }}
                                                />
                                            ) : null,
                                    }}
                                />
                            )}
                        />

                        <Autocomplete
                            disablePortal
                            options={comparisonPeriodOptions}
                            disableClearable
                            size="small"
                            onChange={(event, newValue) => {
                                onCompareDateChange?.(newValue);
                            }}
                            getOptionLabel={(option) => option.label}
                            sx={{ width: 160 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment:
                                            selectedCompareDate ? (
                                                <Chip
                                                    label={
                                                        selectedCompareDate.label
                                                    }
                                                    size=
                                                    "small"
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.50)",
                                                        },
                                                        backgroundColor:
                                                            "rgba(145, 158, 171, 0.32)",
                                                        color:
                                                            "rgba(51, 60, 71, 1)",
                                                    }}
                                                />
                                            ) : null,
                                    }}
                                />
                            )}
                        />
                    </Stack>
                </Box>
            </Box>
        </GridToolbarContainer>
    );
}